import { cloneDeep } from 'lodash'

import { IRegistrationTabs } from '../models/event-registered-users/event-registered-users.interface'
import { IRegistrationTicketInterface } from '../models/registration-tickets/registrationTicket.interface'

export function mergeTicketsWithTabData(
  ticketTabData: IRegistrationTabs['ITicketTab'][],
  registrationTickets: IRegistrationTicketInterface[]
) {
  let ticketTabDataCloned = cloneDeep(ticketTabData)

  // Remove all registrationTickets
  ticketTabDataCloned = ticketTabDataCloned.map((currRow) => {
    return {
      ...currRow,
      registrationTicket: null,
    }
  })

  ticketTabDataCloned = ticketTabDataCloned.map((currRow) => {
    let foundRegistrationTicket = cloneDeep(registrationTickets).filter(
      (currRegistrationTicket) => currRegistrationTicket.ticketItemId === currRow.ticketItemId
    )

    return {
      ...currRow,
      registrationTicket: foundRegistrationTicket?.[0]
        ? {
            ...foundRegistrationTicket[0],
            selectedUnitsCount: foundRegistrationTicket.length || 0,
          }
        : null,
    }
  })

  return ticketTabDataCloned
}
